
import React, { useEffect, useState } from 'react';

import ExternalConfiguration from '../../external-configuration';

// import './Wrapper-custom-3-plain.css';

const Constants = {
  PlayerId: 'custom-3-plain-player',
  PlayerScritpSrc: `${ExternalConfiguration.SelfHostedExternalSrcPaths.custom_3_player}/jwplayer.js`,
};

const Globals = {
  playerScript: null,
  player: null,
};

const onLoad = (event, props) => {
  const playerConfig = {
    playlist: props.custom_3_playerConfiguration.playlist,
    ...props.custom_3_playerConfiguration.customProps,
    key: ExternalConfiguration.Credentials.Custom_3_playerLicenseKey,
  };

  Globals.player = window.jwplayer( Constants.PlayerId);
  Globals.player.setup( playerConfig);
};

export default function Wrapper_custom_3_plain_player( props) {
  const { width, height } = props.custom_3_playerConfiguration?.customProps ?? {};
  const { PlayerId, PlayerScritpSrc } = Constants;
  const { player } = Globals;

  if( player && (player.getWidth() !== width || player.getHeight() !== height)) player.resize( width, height);

  useEffect( () => {
    Globals.playerScript = document.createElement( 'script');
    Globals.playerScript.src = PlayerScritpSrc;
    Globals.playerScript.async = true;
    Globals.playerScript.onload = event => onLoad( event, props);
    document.head.append( Globals.playerScript );
  }, []);

  return (
    <div className='wrapper-custom-3-plain-player-container' style={{ width: window.innerWidth, height: window.innerHeight }}>
      <div id={PlayerId} style={{ width: '100%', height: '100% '}}/>
    </div>
  );
}
